import { belowBreakpointOrEqual, Button, getColor, styled, useBelowBreakpointOrEqual } from 'imaginarity-react-ui';
import * as React from 'react';

const HeadlineTop = styled.div<{ isMobile: boolean }>`
    display: grid;
    grid-template-columns: ${p => p.isMobile ? "max-content 1fr" : "max-content 1fr max-content"};
    position: sticky;
    top: 0px; 
    background: linear-gradient(to top, ${p => getColor(p, "@veryLightGrey")}, ${p => getColor(p, "@mainBackground")}); 
    border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")}; 
    z-index: 9000;
    /* width: ${p => belowBreakpointOrEqual(p, "largeMobile") ? "100%" : "calc(110% + 24px)"};
    transform: ${p => belowBreakpointOrEqual(p, "largeMobile") ? "unset" : "translateX(calc(-5% - 5px))"}; */
    width: ${p => belowBreakpointOrEqual(p, "largeMobile") ? "100%" : "111.12%"};
    margin-left: ${p => belowBreakpointOrEqual(p, "largeMobile") ? 0 : "-5.56%"};
    /* padding-left: calc(5% + 13px);
    padding-right: calc(5% + 12px); */
    padding-left: 5.56%;
    padding-right: 5.56%;
    box-shadow: 0 6px 8px -6px ${p => getColor(p, "@darkGrey")};
    padding-bottom: 10px;
    margin-bottom: 20px;
    gap: 0px;
    margin-top: -2px;
    align-items: center;
    button>div{margin: 0;}
`;
const HeadlineTopLeft = styled.div`
    line-height: 40px;
    font-size: 1.5em;
    font-weight: bolder;
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row: 1;
`;
const HeadlineTopMiddle = styled.div`
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row: 1;
    text-align: right;    
`;
const HeadlineTopRight = styled.div`
    grid-column-start: 3;
    grid-column-end: 4;
    grid-row: 1;
`;
const ExpandedContent = styled.div<{ height: number }>`
    grid-column-start: 1;
    grid-column-end: 4;
    grid-row: 2;
    overflow: hidden;
    transition: height 0.2s ease-in-out;
    height: ${p => p.height}px;
`;
const ExpandedContentInner = styled.div`
    margin-top: 10px;
`;

interface AdminHeaderBarProps {
    title: string;
    rightElement?: JSX.Element;
    expandedElement?: JSX.Element;
}


const AdminHeaderBar = (p: AdminHeaderBarProps) => {

    const { title, rightElement, expandedElement } = p;
    const isMobile = useBelowBreakpointOrEqual("tablet");
    const [showExpanded, setShowExpanded] = React.useState<boolean>(false);
    const [height, setHeight] = React.useState<number>(0);
    const toggleShowExpanded = () => {
        setShowExpanded(f => !f);
    }
    React.useEffect(() => {
        const expandedArea = document.getElementById("expandedArea");
        if (expandedArea) {
            const newHeight = expandedArea.getBoundingClientRect().height;
            setHeight(newHeight);
        }
    }, [showExpanded]);

    return (
        <HeadlineTop isMobile={isMobile}>
            <HeadlineTopLeft>
                {title}
            </HeadlineTopLeft>
            <HeadlineTopMiddle>
                {rightElement && rightElement}
            </HeadlineTopMiddle>
            <HeadlineTopRight>
                {expandedElement &&
                    <Button icon="chevron down" floated='right' kind='halfTransparentButton' onClick={toggleShowExpanded} />
                }
            </HeadlineTopRight>
            <ExpandedContent height={(expandedElement && showExpanded) ? height : 0} >
                <ExpandedContentInner id="expandedArea">
                    {expandedElement}
                </ExpandedContentInner>
            </ExpandedContent>
        </HeadlineTop>
    );
}
export default AdminHeaderBar;